// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge.badge-pill[data-v-25059c8d]{height:2rem;display:inline-flex;align-items:center}.workshop-item>a>div[data-v-25059c8d]{border-bottom:4px solid #c7d121}.workshop-item>a[data-v-25059c8d],.workshop-item>a>div[data-v-25059c8d]{height:100%}", ""]);
// Exports
module.exports = exports;
